module.exports = __webpack_public_path__ + "static/media/header-logo.0938e118.png";